import React from 'react';
import { Moment } from 'moment';
import { StyledIconContainer } from './NotesPreviewCardStyles';
import { FaEnvelope, FaPhoneAlt, FaStickyNote, FaTasks } from 'react-icons/fa';
import DateIcon from './DateIcon';

interface PreviewIconProps {
  type: string;
  isHovered: boolean;
  eventStart?: Moment;
}

const PreviewIcon: React.FC<PreviewIconProps> = ({ type, isHovered, eventStart }) => {
  const month = eventStart ? eventStart.format('MMM') : '';
  const day = eventStart ? eventStart.date().toString() : '';

  return (
    <StyledIconContainer isHovered={isHovered}>
      {type === 'Event' && <DateIcon month={month} day={day} />}
      {type === 'QNote' && <FaStickyNote size="22px" />}
      {type === 'Call Log' && <FaPhoneAlt size="22px" />}
      {type === 'Email' && <FaEnvelope size="22px" />}
      {type === 'Task' && <FaTasks size="22px" />}
    </StyledIconContainer>
  );
};

export default PreviewIcon;
